import { useQuery } from '@tanstack/react-query'
import { PatientService } from 'src/services/patient.service'
import { TPatient } from 'src/types/patient'
import { TPatientForm } from 'src/types/form'
import { TPatientVariable } from 'src/types/variable'

export type TPatientAllVariables = {
  patientForms: TPatientForm[]
  patientVariables: TPatientVariable[]
}

export const usePatientAllVariables = (projectId: number, patient?: TPatient) => {
  const query = useQuery({
    queryKey: ['patients-all-variables', projectId, patient?.id],
    queryFn: () => PatientService.getPatientAllVariables(projectId, patient?.id as number),
    enabled: !!patient && !patient?.isArchived,
  })
  return {
    ...query,
    patientAllVariables: query?.data as TPatientAllVariables | undefined,
  }
}

export const usePatientTimeline = (projectId: number, patient?: TPatient) => {
  const { isLoading, isError, error, data } = useQuery({
    queryKey: ['patient-timeline', projectId, patient?.id],
    queryFn: () => PatientService.getPatientTimeline(projectId, patient?.id as number),
    enabled: !!patient && !patient?.isArchived,
  })
  return { isLoading, isError, error, patientTimeline: data }
}
